// extracted by mini-css-extract-plugin
export default {"videocontainer":"Video_videocontainer__mSmKw"};